import React, { Component } from 'react'
import { withRouter } from "react-router";
// import { appendScript, removeElement, } from '../utils/dom';
import ReactHtmlParser from 'react-html-parser';
import { getPages } from '../utils/request';
import { Link } from "react-router-dom";
import { scrollTo } from "../utils/global";
import { dmy } from "../utils/date"

export class Ecosystem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            attrs :{
                class : "EcosystemScript",
                src : "/js/component/Ecosystem.js",
                async : true,
            },
            remove : ".EcosystemScript", // string or array
            eco : [],
			update: false,
            bc : false,
        };
    }

    componentDidMount() {
		getPages().then((res)=>{
            this.setState({ eco : res })
        
            this.setBreadcrumb()
            // const { attrs, remove } = this.state
            // appendScript(attrs,remove)
		})
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.update===true){
            this.componentDidMount()
        }
        
        this.setBreadcrumb()
    }

    componentWillUnmount(){
        // const { remove } = this.state
        // removeElement(remove)
    }

    setBreadcrumb(){
        const { main } = this.props
        const { bc } = this.state
        const { setBreadcrumb } = this.props

        if(bc===false){
            var title = (main.language)? main.language.MENU_ECOSYSTEM : "-"
            var arr = [{name:title, link:"/ecosystem"}]

            setBreadcrumb(title, arr)
            this.setState({ bc:true })
        }
    }

    render() {
        const { eco } = this.state
        return (
            <main>
                <div role="main" className="main">
                    <div className="page-content-wrapper section-space--inner--120 pb-0" id="Product">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="blog-grid-wrapper">
                                        <div className="row">
                                            {eco.map((p,i)=>(
                                                <div className="col-lg-4 col-md-6" key={i}>
                                                    <div className="blog-post-slider__single-slide blog-post-slider__single-slide--grid-view">
                                                        <div className="blog-post-slider__image section-space--bottom--30">
                                                            <Link to={"/ecosystem/"+p.SLUG} target="_self" onClick={(el)=>{ scrollTo(el) }}>
                                                                <img src={p.FULL_PATH_IMAGE} className="img-fluid" alt=""/>
                                                            </Link>
                                                        </div>
                                                        <div className="blog-post-slider__content">
                                                            <p className="post-date">{dmy(p.DATE_ADDED)}</p>
                                                            <h3 className="post-title">
                                                                <Link to={"/ecosystem/"+p.SLUG} className="text-uppercase" target="_self" onClick={(el)=>{ scrollTo(el) }}>{p.TITLE}</Link>
                                                            </h3>
                                                            { ReactHtmlParser(p.DESC_PAGES.substr(0,300)) }
                                                            <br/>
                                                            <Link to={"/ecosystem/"+p.SLUG} className="see-more-link blog-readmore" target="_self" onClick={(el)=>{ scrollTo(el) }}>
                                                                <span>READ MORE <i className="ion-arrow-right-c"></i></span>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        )
    }
}

export default withRouter(Ecosystem)
